var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLightmode48Filled = function SvgIconLightmode48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 32.7a8.7 8.7 0 1 0 0-17.4 8.7 8.7 0 0 0 0 17.4ZM25.7 7.5h-3.4V13h3.4V7.5ZM25.7 35h-3.4v5.5h3.4V35ZM34.464 11.137l-3.89 3.89 2.405 2.403 3.889-3.889-2.404-2.404ZM15.024 30.57l-3.89 3.889 2.405 2.404 3.889-3.89-2.404-2.403ZM40.5 22.3H35v3.4h5.5v-3.4ZM13 22.3H7.5v3.4H13v-3.4ZM32.974 30.575l-2.403 2.405 3.89 3.888 2.403-2.404-3.89-3.889ZM13.542 11.13l-2.404 2.405 3.89 3.888 2.404-2.405-3.89-3.888Z",
    fill: "current"
  })));
};
export default SvgIconLightmode48Filled;